import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function CloseIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M17.293 5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293.068.076a1 1 0 0 1-1.406 1.407l-.076-.069L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707l-.068-.076A1 1 0 0 1 6.63 5.225l.076.068L12 10.586z" />
    </Icon>
  );
}

CloseIcon.displayName = 'CloseIcon';
